  <kendo-upload [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" [concurrent]="true" [(ngModel)]="myFiles" [multiple]="multiple"
    (select)="onSelect($event)" (success)="onSuccess($event)" (upload)="onUpload($event)" [restrictions]="fileRestrictions" (complete)="onComplete()"
    (remove)="onRemove($event)">
  </kendo-upload>

